import { GroupedData } from './chronological-data.interface';
import { GroupBy } from './group-by.enum';

export class GroupedChronologicalData<T> {
  groupBy: GroupBy;
  data: GroupedData<T>[];

  constructor(groupBy: GroupBy) {
    this.groupBy = groupBy;
    this.data = [];
  }

  /**
   * It takes a callback function and an initial value, and returns a new array of
   * GroupedData objects, where each GroupedData object has a single element in its
   * data array
   * @param callbackfn - A function that accepts up to four arguments. The reduce
   * method calls the callbackfn function one time for each element in the array.
   * @param {T} initialValue - T
   * @returns An array of objects with a single data property.
   */
  reduce(
    callbackfn: (
      previousValue: T,
      currentValue: T,
      currentIndex: number,
      array: T[]
    ) => T,
    initialValue: T
  ): GroupedData<T>[] {
    return this.data.map((group) => {
      return {
        ...group,
        data: (group.data as T[]).reduce(callbackfn, initialValue),
      } as GroupedData<T>;
    });
  }
}
